/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  max-height: 64px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Container = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 8px;
`;
